import { render, staticRenderFns } from "./Sale.vue?vue&type=template&id=7ca3654b"
import script from "./Sale.js?vue&type=script&lang=js&external"
export * from "./Sale.js?vue&type=script&lang=js&external"
import style0 from "./Sale.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports